/*
 * ** WARNING **
 * This file (and all of the files in this folder) is the legacy version of code originally from `src/components/App/App.tsx`.
 * There is a refactored version of this code in `src/rxdb/replication-v2/`.
 * The feature flag `syncEnhancements` is used to toggle between the two versions.
 * **DO NOT MODIFY THIS FILE UNLESS THE CORRESPONDING CHANGES ARE PORTED TO `replication-v2`**
 * See `src/rxdb/replication-v1/README.md` for more details.
 */
import { useContext, useEffect } from 'react';

import { useWindowVisibility } from '@/utilities/hooks/useWindowVisibility';
import { getLastBackgroundedTime, saveBackgroundTimeToLocalStorage } from '@/utilities/syncHelpers';

import { createGoal } from '../actions/goals/Goal';
import { kind as suspend } from '../actions/goals/Stop';
import { dataManagerContext } from '../dataManagerContext';

export function useBackgroundRefresh() {
  const dataManager = useContext(dataManagerContext);
  const windowVisible = useWindowVisibility();

  useEffect(() => {
    // If app is in background for more than 2 minutes, refresh page
    const maxBackgroundBeforeRefresh = 60 * 2; // 2 minutes
    if (windowVisible) {
      const lastBackgroundTime = getLastBackgroundedTime();
      if (lastBackgroundTime && lastBackgroundTime > maxBackgroundBeforeRefresh) {
        // BUG: this preserves the behaviour from the legacy replication code:
        //   * This does a `Suspend` instead of a `Disable`,
        //     thus preserving accessibility to the `Database` and leaving it open to additional incoming data.
        //   * It does not `await` the goal's promise,
        //     which means that the `window.location.reload()` happens before replication can actually complete.
        dataManager.dispatch(createGoal(suspend));
        window.location.reload();
      }
    } else if (windowVisible === false) {
      saveBackgroundTimeToLocalStorage();
    }
  }, [windowVisible, dataManager]);
}
